import { format, parseISO } from 'date-fns';

export const commissionMoney = (value: number): string => value.toLocaleString('en-US', {
  style: 'currency', currency: 'USD', minimumFractionDigits: 2
}).replace('-', '−');
export const commissionWholeMoney = (value: number): string => value.toLocaleString('en-US', {
  style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0
}).replace('-', '−');
export const commissionDate = (value: string | null | undefined): string => value ? format(parseISO(value), 'MMM d, yyyy') : '—';
export const commissionCompactMoney = (value: number): string => {
  const amount = Math.abs(value);
  const sign = value < 0 ? '−' : '';
  return amount >= 1000000 ? `${sign}$${(amount / 1000000).toFixed(2)}M`
    : amount >= 1000 ? `${sign}$${(amount / 1000).toFixed(1)}K` : `${sign}$${amount.toFixed(0)}`;
};
